import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@gymflow/helpers";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import CustomTooltip from "../CustomTooltip";

export type LabelProps = {
  label?: string | ReactNode;
  isRequired?: boolean;
  isOptional?: boolean;
  className?: string;
  helpTooltip?: string;
};

const Label = ({
  label,
  isRequired,
  className,
  isOptional,
  helpTooltip,
}: LabelProps) => {
  const { t } = useTranslation();

  if (!label) return undefined;

  return (
    <div
      className={cn(
        "flex text-sm font-medium text-gray-950 dark:text-gray-0 gap-0.5",
        className,
      )}
    >
      {label}
      {isRequired && <div className="text-error-600">*</div>}
      {isOptional && (
        <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
          {t("components.base.label.optional")}
        </div>
      )}
      <CustomTooltip message={helpTooltip} hideIfEmpty>
        <FontAwesomeIcon
          icon={faQuestionCircle}
          className="size-4 text-gray-500 dark:text-gray-400"
        />
      </CustomTooltip>
    </div>
  );
};

export default Label;
